import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_app_form_item = _resolveComponent("app-form-item")!

  return (_openBlock(), _createBlock(_component_app_form_item, {
    label: _ctx.label,
    "control-class": _ctx.controlClass,
    "error-message": _ctx.errorMessage || _ctx.propError
  }, {
    "label-append": _withCtx(() => [
      _renderSlot(_ctx.$slots, "label-append", {}, undefined, true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_select, _mergeProps({
        ref: "selectRef",
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event))
      }, _ctx.$attrs, {
        placeholder: _ctx.placeholder,
        filterable: _ctx.filterable,
        teleported: false,
        "onHook:mounted": _ctx.cancelReadOnly,
        onVisibleChange: _ctx.cancelReadOnly,
        "popper-class": "select-popper"
      }), {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.key || item.value,
              label: item.label,
              value: item.value
            }, _createSlots({ _: 2 }, [
              _renderList(_ctx.$slots, (_, name) => {
                return {
                  name: name,
                  fn: _withCtx((slotData) => [
                    _renderSlot(_ctx.$slots, name, _mergeProps({ item: item }, slotData), undefined, true)
                  ])
                }
              })
            ]), 1032, ["label", "value"]))
          }), 128))
        ]),
        _: 3
      }, 16, ["modelValue", "placeholder", "filterable", "onHook:mounted", "onVisibleChange"])
    ]),
    _: 3
  }, 8, ["label", "control-class", "error-message"]))
}